enum QueryAction {
  OpenCreatePromoCodeApplicationModalWindow = 'openCreatePromoCodeApplicationModalWindow'
}

export default QueryAction
